import script from "./SelectOption.vue?vue&type=script&lang=ts&setup=true&generic=T%20extends%20Record%3Cstring%2C%20any%3E"
export * from "./SelectOption.vue?vue&type=script&lang=ts&setup=true&generic=T%20extends%20Record%3Cstring%2C%20any%3E"

import "./SelectOption.vue?vue&type=style&index=0&id=51b3e26c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51b3e26c"]])

export default __exports__